import { inject } from '@angular/core'
import { toObservable } from '@angular/core/rxjs-interop'
import {
  patchState,
  signalStore,
  withHooks,
  withMethods,
  withState,
} from '@ngrx/signals'
import { withEventHandlers } from '@ngrx/signals/events'
import { map } from 'rxjs/operators'
import { BroadcastChannelGroup } from '../../broadcasts/enums/broadcast-channel-group'
import { BroadcastChannelVisibility } from '../../broadcasts/enums/broadcast-channel-visibility'
import { BroadcastEvent } from '../../broadcasts/enums/broadcast-event'
import { withBroadcasts } from '../../broadcasts/stores/features/with-broadcasts'
import { BroadcastChannel } from '../../broadcasts/utilities/broadcast-channel'
import { AuthStore } from '../../core/stores/auth.store'
import { ManagerVersion, mapVersion } from '../../core/types/manager-version'
import { AnonymousData } from '../../rest/decorators/mapped'

interface State {
  version: ManagerVersion | null
}

const initialState: State = {
  version: null,
}

export const ManagerVersionStore = signalStore(
  { providedIn: 'root' },
  withState<State>(initialState),
  withBroadcasts(),
  withMethods((store) => ({
    changeVersion(version: ManagerVersion) {
      patchState(store, { version })
    },
  })),
  withHooks((store) => ({
    onInit() {
      store.subscribeToChannel(
        new BroadcastChannel(
          BroadcastChannelGroup.maintenance,
          BroadcastChannelVisibility.public
        ),
        [
          {
            event: BroadcastEvent.managerVersionUpdated,
            process: (data: AnonymousData) => {
              store.changeVersion(mapVersion(data))
            },
          },
        ]
      )
    },
  })),
  withEventHandlers((store, authStore = inject(AuthStore)) => ({
    authVersion$: toObservable(authStore.managerVersion).pipe(
      map((version) => {
        if (version) {
          store.changeVersion(version)
        }
      })
    ),
  }))
)
